import { useCallback, useEffect, useState } from "react";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";
import { Button } from "./ui/button";

export default function ConsoleClaroInvites() {
  const [invites, setInvites] = useState([]);
  const load = useCallback(() => { api.get("/console/my-claro-invites").then(({ data }) => setInvites(data || [])).catch(() => {}); }, []);
  useEffect(() => { load(); }, [load]);
  if (!invites.length) return null;

  const respond = async (id, decision) => {
    try {
      await api.post(`/console/my-claro-invites/${id}/${decision}`);
      toast.success(decision === "accept" ? "Accepted. The entity now appears in your entity switcher." : "Invitation declined");
      load();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  return (
    <div className="border border-indigo-300 bg-indigo-50/60 p-4 space-y-2" data-testid="console-claro-invites">
      <div className="font-semibold text-sm">Entity invitations awaiting your response</div>
      {invites.map((i) => (
        <div key={i.id} className="flex flex-wrap items-center gap-3 text-sm" data-testid={`console-invite-${i.id}`}>
          <span><b>{i.entity_name}</b> — invited by {i.invited_by} ({i.invited_by_email}) on {i.created_at?.slice(0, 10)}: “{i.reason}”</span>
          <Button size="sm" className="rounded-none" onClick={() => respond(i.id, "accept")} data-testid={`console-invite-accept-${i.id}`}>Accept</Button>
          <Button size="sm" variant="outline" className="rounded-none" onClick={() => respond(i.id, "decline")} data-testid={`console-invite-decline-${i.id}`}>Decline</Button>
        </div>
      ))}
    </div>
  );
}
